<template>
  <div class="confirm-email-popup__wrapper">
    <base-popup class="confirm-email-popup" ref="popup" :without-icon="true">
      <template #header="{ close }">
        <div class="confirm-email-popup__header">
          <div class="confirm-email-popup__title">
            {{ $t('bills.popup.confirm-email-popup.title') }}
          </div>
          <popup-close-button
            class="confirm-email-popup__close"
            @click="close"
          ></popup-close-button>
        </div>
      </template>
      <template #content>
        <div class="confirm-email-popup__content">
          <text-input v-model:value="email" title="E-mail" />
        </div>
      </template>
      <template #actions>
        <div class="confirm-email-popup__actions">
          <primary-button
            :label="$t('bills.popup.confirm-email-popup.title')"
            @click="confirmEmail"
          />
        </div>
      </template>
    </base-popup>
  </div>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PopupCloseButton from '@vue-app/components/base/button/PopupCloseButton.vue'
import SocialShareButtons from '@vue-app/components/base/share/SocialShareButtons.vue'
import LinkInput from '@vue-app/components/base/input/LinkInput.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'

export default {
  name: 'ConfirmEmailPopup',
  components: {
    PrimaryButton,
    TextInput,
    SuccessNotification,
    LinkInput,
    SocialShareButtons,
    PopupCloseButton,
    BasePopup,
  },
  props: {
    template: Object,
  },

  data() {
    return {
      email: '',
    }
  },
  methods: {
    open(email) {
      this.email = email
      return this.$refs.popup.open()
    },
    async confirmEmail() {
      this.$refs.popup.confirm(this.email)
    },
  },
}
</script>

<style lang="scss" scoped>
.confirm-email-popup {
  :deep(.popup) {
    width: 395px;
    padding: 30px 0 52px;
  }

  &__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    height: 30px;
    margin-bottom: 44px;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #585f6d;
  }

  &__close {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
  }

  &__content,
  &__actions {
    padding: 0 50px;
  }

  &__input {
    margin-top: 60px;
    padding: 0 52px;
  }
}
</style>
